import axios from 'axios';
import { dispatch } from 'nike-re-framejs';
import { fromJS } from 'immutable';

import { catcher } from '@/_http/utils';
import { MESSAGES } from '@/routing/routes';
import { navigate } from '@/routing';
import { indexById } from 'nike-ui/src/components/turboLive/push/indexingUtils';

export const loadAccountMessages = swallow => db => {
    axios
        .get('/api/account/v2/messages')
        .then(messages => {
            dispatch(db =>
                db.setIn(['account', 'messages'], indexById(messages)).setIn(['account', 'messagesLoading'], false)
            );
        })
        .catch(error => (swallow ? catcher.swallow(error) : catcher.handleMasterError(error)));
    return db.setIn(['account', 'messagesLoading'], true);
};

export const loadAccountMessage = id => db => {
    axios
        .get(`/api/account/v2/messages/${id}`)
        .then(message =>
            dispatch(db =>
                db.setIn(['account', 'messages', id], fromJS(message)).setIn(['account', 'messageLoading'], false)
            )
        )
        .catch(error => {
            catcher.swallow(error);
            dispatch(db => db.setIn(['account', 'messageLoading'], false));
        });
    return db.setIn(['account', 'messageLoading'], true);
};

export const deleteAccountMessage = id => db => {
    axios
        .delete(`/api/account/v2/messages/${id}`)
        .then(() => navigate(MESSAGES))
        .catch(catcher.handleMasterError);
    return db;
};
export const loadNewAccountMessages = db => {
    if (db.get('loggedIn')) {
        axios
            .get('/api/account/v2/messages/new-count')
            .then(count => {
                dispatch(db => db.setIn(['account', 'newMessages'], count));
            })
            .catch(catcher.swallow);
    }
};
